export const contractTypeKeys = {
  all: ['contractTypes'] as const,
  lists: () => [...contractTypeKeys.all, 'list'] as const,
  list: (companyId: string) => [...contractTypeKeys.lists(), companyId] as const,
  details: () => [...contractTypeKeys.all, 'detail'] as const,
  detail: (id: string) => [...contractTypeKeys.details(), id] as const,
  names: () => [...contractTypeKeys.all, 'names'] as const,
  byCompany: (companyId: string) => [...contractTypeKeys.all, 'byCompany', companyId] as const,
}
